import React, { useContext } from 'react';
import { returnWeekDays, MonthName } from '../../../utils/consts/months';
import { Utility } from './utils';
import { FormattedMessage } from 'react-intl';
import { LocaleSettingContext } from '../../../utils/consts/localeSetting';
import { change__proto__ } from '../../../utils/utility/prototypeModifier';

let isDarkMode = false;
function DateSection({ altDateType, ...props }) {
  isDarkMode = props.isDarkMode;
  const localState = JSON.parse(localStorage.getItem('state'));
  const { direction, timeZone } = useContext(LocaleSettingContext),
    { skipdays, days } = Utility._buildMonth(
      props.monthIndex,
      direction,
      timeZone,
      localState?.language?.name,
    )[0];
  change__proto__.call(DateSection, 'languageName', localState?.language?.name);
  return (
    <>
      <div className="col p-0 px-2 align-items-center text-primary d-flex">
        <DateSection.WeekDays />
      </div>
      <div className="col p-0 align-items-center pb-2 d-flex">
        <DateSection.Month>
          <DateSection.SkipedDays skipdays={skipdays} />
          <DateSection.Days days={days} {...props}>
            {(day) => (
              <div className={`border ${isDarkMode ? ' day_dark ' : 'day'}`}>
                <DateSection.DayTitle day={day} />
                <DateSection.Day day={day} holiday={props.holidays} />
                <DateSection.AlternativeDate type={altDateType} day={day} />
              </div>
            )}
          </DateSection.Days>
        </DateSection.Month>
      </div>
    </>
  );
}

DateSection.createCustomProto({
  WeekDays: function () {
    return returnWeekDays(DateSection.languageName).map((day) => (
      <div
        key={day}
        className={`text-center font-smaller font-weight-bold my-2 p-1 ${
          isDarkMode ? 'text-white' : ' text-muted '
        }`}
        style={{ width: 'calc(100% / 7)' }}
      >
        <DateSection.WeekDay {...{ day }} />
      </div>
    ));
  },

  WeekDay: function ({ day }) {
    if (DateSection.languageName !== 'fa') return day.substring(0, 3);
    return <small>{day}</small>;
  },

  Month: function ({ children }) {
    return (
      <div className="col p-0 px-2">
        <ul className="datepicker_month d-flex flex-wrap">{children}</ul>
      </div>
    );
  },
  SkipedDays: function ({ skipdays }) {
    return skipdays.map((_, index) => (
      <li key={index} className="datepicker_day different-month">
        <div className="day" />
      </li>
    ));
  },
  Days: function ({
    days,
    children,
    select,
    selectedDate,
    disableBeforeDate,
    holidays,
  }) {
    return days.map((day, index) => {
      const holiday = {};
      const isDisabled = Utility.checkDateDisabled(day.date, disableBeforeDate),
        isDayOff = Utility.isDayOff(
          day.date,
          DateSection.languageName,
          holiday,
        ),
        isSelected = selectedDate == day.date.toLocaleString(),
        className = Utility.setDayClass(
          day.isToday,
          isSelected,
          isDisabled,
          isDayOff,
          isDarkMode,
        );
      const shamsiHolidays = holidays?.find((holiday) => {
        if (holiday?.dateType === 'shamsi') {
          return (
            parseInt(holiday.month) === parseInt(day.shamsi[1]) &&
            parseInt(holiday.day) === parseInt(day.shamsi[2])
          );
        }
      });
      const miladiHolidays = holidays?.find((holiday) => {
        if (holiday?.dateType === 'miladi') {
          return (
            parseInt(holiday.month) === parseInt(day.miladi[1]) &&
            parseInt(holiday.day) === parseInt(day.miladi[2])
          );
        }
      });
      const hejriHolidays = holidays?.find((holiday) => {
        if (holiday?.dateType === 'ghamari') {
          return (
            parseInt(holiday.month) === parseInt(day.hijri[1]) &&
            parseInt(holiday.day) === parseInt(day.hijri[2])
          );
        }
      });

      let isVacationHoliday = [];
      if (shamsiHolidays) {
        isVacationHoliday.push(shamsiHolidays);
      }
      if (miladiHolidays) {
        isVacationHoliday.push(miladiHolidays);
      }
      if (hejriHolidays) {
        isVacationHoliday.push(hejriHolidays);
      }

      return (
        <li
          className={`datepicker_day p-1 ${
            isVacationHoliday.length > 0 && 'text-danger'
          } ${className} `}
          key={index}
          onClick={select.bind(null, day, !isDisabled)}
        >
          {children(day)}
        </li>
      );
    });
  },
  DayTitle: function ({ day }) {
    const className = 'today d-none d-sm-block text-center';
    if (day.isToday) {
      return (
        <div className={`${className} `}>
          <FormattedMessage id="booking.today" />
        </div>
      );
    } else {
      const type = DateSection.languageName === 'fa' ? 'shamsi' : 'miladi';
      return (
        <div className={`${className} `} style={{ paddingTop: '1px' }}>
          <MonthName type={type} monthIndex={day[type][1]} abbr />
        </div>
      );
    }
  },

  Day: function ({ day }) {
    const mainDay = day[
      DateSection.languageName === 'fa' ? 'shamsi' : 'miladi'
    ][2].padStart(2, '0');
    return <div className={`date text-center font-weight-bold`}>{mainDay}</div>;
  },

  AlternativeDate: function ({ day, type }) {
    const { direction, fontFamily, className, abbr } =
      Utility.createAltDateObject(type, isDarkMode);
    return (
      <div className={className} style={{ direction }}>
        <span style={{ fontFamily, fontSize: '0.5rem' }}>
          {day[type][2]}&nbsp;
          <MonthName type={type} monthIndex={day[type][1]} abbr={abbr} />
        </span>
      </div>
    );
  },
});

export { DateSection };
